export interface ProfileData {
  competences: CompetenceData,
  experiences: any
}

export interface CompetenceData {
  competences: object
  itSkills: object
  languages: object
  personalCompetences: object
  driverLicenses?: object
}

//Item can have a bit different look, but this interface should sum it up:
export interface DisplayItem {
  Id: number
  id?: number
  selected?: boolean
  sortOrder?: number
  Text?: string
  deleted?: boolean
  description?: string
  end?: null
  endMonth?: boolean
  level?: string
  organization?: string
  organizationId?: number | null
  publicState?: boolean
  start?: string
  startMonth?: true
  type: ItemTypes
}

export enum ItemTypes {
  ProfessionalCompetences = 'ProfessionalCompetences',
  PersonalCompetences = 'PersonalCompetences',
  Languages = 'Languages',
  ItSkills = 'ItSkills',
  Licenses = 'Licenses',
  WorkExperiences = 'WorkExperiences',
  Educations = 'Educations',
  Courses = 'Courses',
  VolunteerWork = 'VolunteerWork',
  JobTypes = 'JobTypes',
  JobGoals = 'JobGoals',
  JobFunctions = 'JobFunctions'
}